import React from 'react';
import { connect } from 'react-redux';

import ProgressBar from '../../components/common/progressBar/ProgressBar';


const ProgressBarContainer = props => {

    const {
        progressBar: {
            processing,
            processingPercentage,
            
        }
    } = props;

    if (!processing) {
        return null;
    }

    return (
        <ProgressBar processingPercentage = { processingPercentage } /> 
    );
};

const mapStateToProps = state => ({
    progressBar: state.common.progress
});

export default connect(mapStateToProps)(ProgressBarContainer);